import React from 'react';
import { KiteIcon, KiteLink } from '@kite/react-kite';
import styles from 'components/footer/styles/Footer.module.scss';
import { TrackingHook, useTracking } from 'react-tracking';
import { PageNSTranslationFileKeys, usePageTranslation } from 'translation/hooks';
import {
  getPortalSocialMediaLinkFacebook,
  getPortalSocialMediaLinkInstagram,
  getPortalSocialMediaLinkLinkedin,
  getPortalSocialMediaLinkX,
  getPortalSocialMediaLinkYoutube,
  LinkItemInterface,
} from 'app-constants';
import { isSMBPortal } from 'utils/applicationHelper';

const SocialMediaIcon: React.FC = () => {
  const { trackEvent }: TrackingHook = useTracking({ page: 'login', component: 'SocialMediaIcon' });
  const { t } = usePageTranslation('linksCopy');

  const socialMediaLinks: LinkItemInterface[] = [getPortalSocialMediaLinkX(), getPortalSocialMediaLinkFacebook()];

  if (isSMBPortal()) {
    socialMediaLinks.push(getPortalSocialMediaLinkLinkedin());
  } else {
    socialMediaLinks.push(getPortalSocialMediaLinkInstagram());
  }
  socialMediaLinks.push(getPortalSocialMediaLinkYoutube());

  const itemsList = socialMediaLinks.map(({ href, icon, uiName, stdName }, index) => {
    return (
      <span className={styles.socialMediaIcon} key={index}>
        <KiteLink
          target="_blank"
          href={href}
          type="inline"
          onClick={() =>
            trackEvent({
              event: 'loginFooterLink',
              linkObject: { uiName: uiName, stdName },
              url: href,
            })
          }
        >
          <KiteIcon
            className={styles.iconSizeKiteOverride}
            ariaLabel={t(uiName as PageNSTranslationFileKeys<'linksCopy'>)}
            icon={`ki-${icon}`}
          />
        </KiteLink>
      </span>
    );
  });

  return (
    <div className={styles.socialIconsContainer}>
      <h2 className={styles.srOnly}>{t('socialMediaDescription')}</h2>
      {itemsList}
    </div>
  );
};

export default SocialMediaIcon;
